export default __webpack_public_path__ + "static/media/LOGOS_TRANSPARENTE-08.b0ac92ea.png";